import { Component, OnInit } from '@angular/core';
import { DwChildConfigBaseComponent } from '@devwareapps/devware-cap';
import { FlightSchoolSettingsConfig } from '../../../../models/flight-school-settings-config.model';

@Component({
  selector: 'app-flight-school-settings-config',
   template: `
    <div>
      <div dwRow>
          <div dwCol="12">
              <label class="label">Config Key</label>
              <input type="text" [(ngModel)]="config.configKeyPart" (ngModelChange)="onChange()" class="form-control">
          </div>
      </div>
    </div>
  ` 
})
export class FlightSchoolSettingsConfigComponent extends DwChildConfigBaseComponent<FlightSchoolSettingsConfig> {
 
  getDefaultConfig(): FlightSchoolSettingsConfig {
    return {
      configKeyPart: 'profile'
    }; 
  }

} 

